module.exports = __webpack_public_path__ + "static/media/logo.df19d634.svg";